import { useState } from "react";
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet } from "@fortawesome/free-solid-svg-icons";
import PortfolioCard from "../components/PortfolioCard";
import BitcoinMarketStats from '../components/BitcoinMarketStats';
import CoinsPortfolio from "../components/CoinsPortfolio";
import StockDashboard from "../components/StockDashboard";
import PortfolioDashboard from "../components/PortfolioDashboard";
import ReferralCard from "../components/ReferralCard";
import BalanceOverview from "../components/BalanceOverview"; 
import CustomCopyTrade from "../components/CustomCopyTrade"; 
import TokenBalances from "../components/TokenBalances"; 
import RewardBalance from "../components/RewardBalance"; 
import BalanceCard2 from "../components/BalanceCard2"; 
import BalanceCard3 from "../components/BalanceCard3"; 

function Components() {
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const toggleSidebar = () => {
  setIsSidebarOpen(!isSidebarOpen);
};
const [notificationbar, setNotificationbar] = useState(false);
const toggleNotification = () => {
  setNotificationbar(!notificationbar);
};
const [settingsBar, setSettingsBar] = useState(false);
const toggleSettingsBar = () => {
  setSettingsBar(!settingsBar);
};

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification
          isOpen={notificationbar}
          toggleNotification={toggleNotification}
        />
        <Sidebar
          title="Components"
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          toggleSettingsBar={toggleSettingsBar}
          settingsBar={settingsBar}
        />
        <div className="col ps-md-2 mainBar">
          <Header
            title="Components"
            icon={
              <FontAwesomeIcon icon={faWallet} style={{ fontSize: "16px" }} />
            }
            toggleSidebar={toggleSidebar}
            toggleNotification={toggleNotification}
            toggleSettingsBar={toggleSettingsBar}
          />
          <main>
            <div className="row">
                  <div className="col-md-12"> <PortfolioCard /></div>   
                  <div className="col-md-12 mb-5"> <TokenBalances /></div>   
                  <div className="col-md-12 mb-5"> <RewardBalance /></div>   
                  <div className="col-md-8"> <BitcoinMarketStats /></div>  
                  <div className="col-md-4"> <CoinsPortfolio /></div>  

                  <div className="col-md-8"> <PortfolioDashboard /> </div>
                  <div className="col-md-4"> <ReferralCard /> </div>
                  <div className="col-md-4"> <CustomCopyTrade /> </div>
                  <div className="col-md-4"> <BalanceCard2 /> </div>
                  <div className="col-md-4"> <BalanceCard3 /> </div>
                  <div className="col-md-12"> <BalanceOverview /></div>   
                  <div className="col-md-12"> <StockDashboard /> </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Components;
